import React, { Component } from "react";
import { Menu, Visibility } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import "../containers/styles/common.css";

const menuStyle = {
  border: "grove #E0E0E0",
  borderRadius: 0,
  transition: "box-shadow 0.3s ease, padding 0.3s ease",
  backgroundColor: "#FF5733",
  height: "80px",
  width: "100%",
};

const fixedMenuStyle = {
  backgroundColor: "#FF5733",
  border: "1px solid #ddd",
  boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.2)",
  height: "60px",
  paddingLeft: "50px",
};

class HeadDetail extends Component {
  state = {
    menuFixed: false,
    overlayFixed: false,
  };

  stickOverlay = () => this.setState({ overlayFixed: true });

  stickTopMenu = () => this.setState({ menuFixed: true });

  unStickOverlay = () => this.setState({ overlayFixed: false });

  unStickTopMenu = () => this.setState({ menuFixed: false });

  render() {
    const { t } = this.props;

    return (
      <div>
        <Visibility
          onBottomPassed={this.stickTopMenu}
          onBottomVisible={this.unStickTopMenu}
          once={false}
        >
          <Menu
            borderless
            style={{
              backgroundColor: "#3f83c2",
              padding: "20px",
              margin: 0,
              color: "white",
              fontWeight: "bold",
            }}
          >
            <div style={{ width: "100%" }}>

              {/* ===== TÍTULO ===== */}
              <div
                style={{
                  textAlign: "center",

                  fontSize: "18px",
                  marginBottom: "20px",
                }}
              >
                {this.props.cruise_name}
              </div>

              {/* ===== CONTENIDO ===== */}
              <div className="grid grid-cols-1 md:grid-cols-3">
                <div className="flex md:space-y-4 flex-col col-span-2">
                  <span className="head-label">
                    {t("head_detail_yacht")}:  {this.props.yacht_name}
                  </span>
                  <span className="head-label">
                    {t("head_detail_itinerary")}: {this.props.itinerary_name}
                  </span>
                </div>

                <div className="flex flex-col md:space-y-4">
                  <span className="head-label">
                    {t("head_detail_startDate")}: {this.props.start_date}
                  </span>
                  <span className="head-label">
                    {t("head_detail_endDate")}: {this.props.end_date}
                  </span>
                </div>
              </div>
            </div>
          </Menu>
        </Visibility>
      </div>
    );
  }
}

export default withTranslation()(HeadDetail);
